
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
  ogType?: string;
  twitterCard?: string;
  twitterCreator?: string;
  canonical?: string;
  noIndex?: boolean;
  structuredData?: Record<string, any>;
  children?: React.ReactNode;
}

const SEOHead: React.FC<SEOProps> = ({
  title = "Build MPVs, Web Apps, Internal Tools Faster, Cheaper and Better.",
  description = "Build MPVs, Web Apps, Internal Tools Faster, Cheaper and Better.",
  keywords = "ai web apps, internal tools, custom software development, web application development, business automation",
  ogImage = "/lovable-uploads/6199980b-2959-40aa-b400-2904c4e09b32.png",
  ogUrl,
  ogType = "website",
  twitterCard = "summary_large_image",
  twitterCreator = "@lovabuild",
  canonical,
  noIndex = false,
  structuredData,
  children
}) => {
  const siteUrl = "https://lovabuild.com"; // Updated to your actual domain
  const fullUrl = ogUrl ? ogUrl : `${siteUrl}${window.location.pathname}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Robots Meta Tags */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Canonical Tag */}
      {canonical ? (
        <link rel="canonical" href={canonical} />
      ) : (
        <link rel="canonical" href={fullUrl} />
      )}
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:site_name" content="LovaBuild" />
      
      {/* Twitter Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:creator" content={twitterCreator} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      
      {children}
    </Helmet>
  );
};

export default SEOHead;
